jQuery(document).ready(function ($) {
    var page = 2; // Initial page number for the next set of posts
    var loading = false; // To prevent multiple AJAX requests

    // Select the button element and retrieve the data-category attribute
    $('.btn-load-more').on('click', function () {
        if (!loading) {
            loading = true;
            
            $.ajax({
                url: themeData.ajax_url,
                type: 'POST',
                data: {
                action: 'load_more_posts',
                page: page,
                nonce: themeData.nonce
            },
                success: function (response) {
                    console.log('AJAX response:', response);
                    if (response.includes('No more posts to show.')) {
                    
                        // Create a hidden div to store the new posts
                        var $newPosts = $('<div>').html(response).hide();

                        // Append the new posts to the container and fade them in
                        $('.newsroom .container').append($newPosts);
                        $newPosts.fadeIn(500);

                        page++;
                        loading = false;
                        // If no more posts, hide the "Load More" button
                        $('#btn-load-more').hide();
                        $('.no-more').show(); // Add this line to display the message
                    } else {
                    
                        // Create a hidden div to store the new posts
                        var $newPosts = $('<div>').html(response).hide();

                        // Append the new posts to the container and fade them in
                        $('.newsroom .load-more-container').append($newPosts);
                        $newPosts.fadeIn(500);

                        page++;
                        loading = false;
                    }
                },
                error: function (errorThrown) {
                    console.log(errorThrown);
                    loading = false;
                }
            });
        }
    });
});
